import { graphql } from "gatsby";
import React from "react";
import { Link } from "./link";
import useRepairabilityIndexImg from "../../hooks/use-repairability-index";
import classNames from "classnames";

const RepairabilityIndex = ({ data, origin, indexValue, link, lineId }) => {
 // console.log({ data, origin, indexValue, link, lineId });
  const indexUrl = useRepairabilityIndexImg(
    indexValue && link ? indexValue : data?.indexValue,
    lineId
  );
  const isDurability = indexUrl?.includes("durability");
  const iconTypeClassName = isDurability ? "durability" : "repairability";

  return indexUrl ? (
    <Link
      to={indexValue && link ? link : data.pdfDocument.node.publicURL}
      target="_blank"
      rel="noreferrer"
      className={classNames(
        `prodotti__doc-${iconTypeClassName}`,
        origin === "product-card" && `prodotti__doc-${iconTypeClassName}-product-card`
      )}
    >
      <img
        src={indexUrl}
        className={isDurability ? "icon-durability" : "icon-repairability"}
        alt={indexValue && link ? indexValue : data?.indexValue}
      />
      <span
        className={classNames(
          `prodotti__doc-${iconTypeClassName}--value`,
          origin === "product-card" && `prodotti__doc-${iconTypeClassName}--value-product-card`
        )}
      >
        {indexValue && link ? indexValue : data?.indexValue}
      </span>
      <span
        className={classNames(
          `prodotti__doc-${iconTypeClassName}--ten`,
          origin === "product-card" &&
            indexValue &&
            link &&
            `prodotti__doc-${iconTypeClassName}--ten-product-card`
        )}
      >
        /10
      </span>
    </Link>
  ) : null;
};

export default RepairabilityIndex;

export const fragment = graphql`
  fragment RepairabilityIndexFragment on LiferayRepairabilityIndex {
    product {
      indexValue
      sku
      pdfDocument {
        node {
          publicURL
        }
        value {
          fileExtension
        }
      }
    }
  }
`;
